export interface ILandingData {
  title: string;
  description: string;
  metaTitle: string;
  metaDescription: string;
  heroDescription?: string;
  noIndex?: boolean;
}

export enum TextType {
  Title = "title",
  Description = "description",
  Subtitle = "subTitle"
}

export enum LocationType {
  Head = "head",
  Header = "hero"
}

export enum LandingName {
  ProductDetail = "productDetail"
}
